function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1968(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 28.74,
    height: 18.26,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0433333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.37,
    y: 9.13,
    fontFamily: "Arial"
  }, "\n        Vinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 18.26,
    width: 28.74,
    height: 21.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.242
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.37,
    y: 28.865000000000002,
    fontFamily: "Arial"
  }, "\n        Noble\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 39.48,
    width: 28.74,
    height: 22.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.37,
    y: 50.81999999999999,
    fontFamily: "Arial"
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 62.16,
    width: 28.74,
    height: 24.66,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.37,
    y: 74.49,
    fontFamily: "Arial"
  }, "\n        Holmes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 86.82,
    width: 28.74,
    height: 27.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.558333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.37,
    y: 100.49499999999999,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 114.18,
    width: 28.74,
    height: 33.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.37,
    y: 130.72,
    fontFamily: "Arial"
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 147.26,
    width: 28.74,
    height: 33.15,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.37,
    y: 163.83499999999998,
    fontFamily: "Arial"
  }, "\n        Harrison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 180.41,
    width: 28.74,
    height: 33.18,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.747999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.37,
    y: 197,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 213.59,
    width: 28.74,
    height: 34.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.185
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.37,
    y: 231.055,
    fontFamily: "Arial"
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 248.53,
    width: 28.74,
    height: 36.4,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.747999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.37,
    y: 266.73,
    fontFamily: "Arial"
  }, "\n        Meigs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 284.93,
    width: 28.74,
    height: 37.46,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.105714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.37,
    y: 303.66,
    fontFamily: "Arial"
  }, "\n        Hocking\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 322.39,
    width: 28.74,
    height: 37.94,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.79
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.37,
    y: 341.36,
    fontFamily: "Arial"
  }, "\n        Morrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 360.32,
    width: 28.74,
    height: 38.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.79
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.37,
    y: 379.34,
    fontFamily: "Arial"
  }, "\n        Gallia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 398.36,
    width: 28.74,
    height: 38.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.105714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.37,
    y: 417.40000000000003,
    fontFamily: "Arial"
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 436.44,
    width: 28.74,
    height: 39.15,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.105714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.37,
    y: 456.015,
    fontFamily: "Arial"
  }, "\n        Wyandot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 475.59,
    width: 28.74,
    height: 44.07,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.747999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.37,
    y: 497.625,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 519.67,
    width: 28.74,
    height: 44.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.105714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.37,
    y: 541.775,
    fontFamily: "Arial"
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 563.88,
    width: 28.74,
    height: 44.31,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.105714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.37,
    y: 586.035,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 608.19,
    width: 28.74,
    height: 45.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.747999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.37,
    y: 631.0450000000001,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 653.89,
    width: 28.74,
    height: 46.11,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.747999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.37,
    y: 676.9449999999999,
    fontFamily: "Arial"
  }, "\n        Perry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.74,
    y: 0,
    width: 33.61,
    height: 40.38,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.801428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.545,
    y: 20.19,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.36,
    y: 0,
    width: 33.79,
    height: 40.38,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.758
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.255,
    y: 20.19,
    fontFamily: "Arial"
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96.15,
    y: 0,
    width: 33.95,
    height: 40.38,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.8500000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.125,
    y: 20.19,
    fontFamily: "Arial"
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.1,
    y: 0,
    width: 37.1,
    height: 40.38,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.183333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 148.65,
    y: 20.19,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.2,
    y: 0,
    width: 37.35,
    height: 40.38,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.2250000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 185.875,
    y: 20.19,
    fontFamily: "Arial"
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 204.55,
    y: 0,
    width: 38.11,
    height: 40.38,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.351666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 223.60500000000002,
    y: 20.19,
    fontFamily: "Arial"
  }, "\n        Preble\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 242.65,
    y: 0,
    width: 38.39,
    height: 40.38,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.79875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 261.845,
    y: 20.19,
    fontFamily: "Arial"
  }, "\n        Highland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.04,
    y: 0,
    width: 38.5,
    height: 40.38,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.8125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 300.29,
    y: 20.19,
    fontFamily: "Arial"
  }, "\n        Pickaway\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.54,
    y: 0,
    width: 39.07,
    height: 40.38,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.341111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 339.07500000000005,
    y: 20.19,
    fontFamily: "Arial"
  }, "\n        Champaign\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358.62,
    y: 0,
    width: 39.65,
    height: 40.38,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.608333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 378.445,
    y: 20.19,
    fontFamily: "Arial"
  }, "\n        Hardin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 398.27,
    y: 0,
    width: 41.33,
    height: 40.38,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 418.935,
    y: 20.19,
    fontFamily: "Arial"
  }, "\n        Williams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 439.59,
    y: 0,
    width: 41.46,
    height: 40.38,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 460.32,
    y: 20.19,
    fontFamily: "Arial"
  }, "\n        Van_Wert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 481.05,
    y: 0,
    width: 41.49,
    height: 40.38,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.486666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 501.795,
    y: 20.19,
    fontFamily: "Arial"
  }, "\n        Coshocton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 522.54,
    y: 0,
    width: 42.78,
    height: 40.38,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.0475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 543.93,
    y: 20.19,
    fontFamily: "Arial"
  }, "\n        Defiance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.32,
    y: 0,
    width: 43.55,
    height: 40.38,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.73
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 587.095,
    y: 20.19,
    fontFamily: "Arial"
  }, "\n        Mercer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 608.87,
    y: 0,
    width: 45.47,
    height: 40.38,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.0475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 631.605,
    y: 20.19,
    fontFamily: "Arial"
  }, "\n        Guernsey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 654.34,
    y: 0,
    width: 45.66,
    height: 40.38,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.076
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 677.1700000000001,
    y: 20.19,
    fontFamily: "Arial"
  }, "\n        Logan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.74,
    y: 40.38,
    width: 47.94,
    height: 39.01,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.501666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.709999999999994,
    y: 59.885000000000005,
    fontFamily: "Arial"
  }, "\n        Ottawa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.74,
    y: 79.39,
    width: 47.94,
    height: 39.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.55
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.709999999999994,
    y: 99.03999999999999,
    fontFamily: "Arial"
  }, "\n        Shelby\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.74,
    y: 118.69,
    width: 47.94,
    height: 40.25,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.709999999999994,
    y: 138.815,
    fontFamily: "Arial"
  }, "\n        Ashland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.74,
    y: 158.94,
    width: 47.94,
    height: 40.38,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.709999999999994,
    y: 179.13,
    fontFamily: "Arial"
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.74,
    y: 199.32,
    width: 47.94,
    height: 42.33,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.055
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.709999999999994,
    y: 220.48499999999999,
    fontFamily: "Arial"
  }, "\n        Athens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.74,
    y: 241.65,
    width: 47.94,
    height: 42.45,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.30625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.709999999999994,
    y: 262.875,
    fontFamily: "Arial"
  }, "\n        Auglaize\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.74,
    y: 284.1,
    width: 47.94,
    height: 42.57,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.6425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.709999999999994,
    y: 305.38500000000005,
    fontFamily: "Arial"
  }, "\n        Knox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.74,
    y: 326.67,
    width: 47.94,
    height: 45.72,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.709999999999994,
    y: 349.53000000000003,
    fontFamily: "Arial"
  }, "\n        Huron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.74,
    y: 372.39,
    width: 47.94,
    height: 52.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.588
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.709999999999994,
    y: 398.61,
    fontFamily: "Arial"
  }, "\n        Darke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.74,
    y: 424.83,
    width: 47.94,
    height: 52.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.794
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.709999999999994,
    y: 451.16999999999996,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.74,
    y: 477.5,
    width: 47.94,
    height: 54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.9925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.709999999999994,
    y: 504.5,
    fontFamily: "Arial"
  }, "\n        Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.74,
    y: 531.51,
    width: 47.94,
    height: 54.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.9925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.709999999999994,
    y: 558.62,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.74,
    y: 585.73,
    width: 47.94,
    height: 56.85,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.9925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.709999999999994,
    y: 614.155,
    fontFamily: "Arial"
  }, "\n        Sandusky\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.74,
    y: 642.58,
    width: 47.94,
    height: 57.42,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.985
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.709999999999994,
    y: 671.2900000000001,
    fontFamily: "Arial"
  }, "\n        Ross\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.69,
    y: 40.38,
    width: 49.12,
    height: 57.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.186666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 101.25,
    y: 69.235,
    fontFamily: "Arial"
  }, "\n        Geauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.81,
    y: 40.38,
    width: 49.36,
    height: 57.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.226666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.49,
    y: 69.235,
    fontFamily: "Arial"
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.17,
    y: 40.38,
    width: 52.04,
    height: 57.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.673333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.19,
    y: 69.235,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.21,
    y: 40.38,
    width: 52.77,
    height: 57.71,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.538571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 253.595,
    y: 69.235,
    fontFamily: "Arial"
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279.98,
    y: 40.38,
    width: 55.69,
    height: 57.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.138
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307.82500000000005,
    y: 69.235,
    fontFamily: "Arial"
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.67,
    y: 40.38,
    width: 55.78,
    height: 57.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.296666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 363.56,
    y: 69.235,
    fontFamily: "Arial"
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 391.45,
    y: 40.38,
    width: 57.57,
    height: 57.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.3925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 420.235,
    y: 69.235,
    fontFamily: "Arial"
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 449.02,
    y: 40.38,
    width: 57.75,
    height: 57.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.618333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 477.895,
    y: 69.235,
    fontFamily: "Arial"
  }, "\n        Medina\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 506.78,
    y: 40.38,
    width: 61.04,
    height: 57.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.412222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 537.3,
    y: 69.235,
    fontFamily: "Arial"
  }, "\n        Fairfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 567.82,
    y: 40.38,
    width: 64.2,
    height: 57.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.4275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 599.9200000000001,
    y: 69.235,
    fontFamily: "Arial"
  }, "\n        Wood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 632.02,
    y: 40.38,
    width: 67.98,
    height: 57.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.412222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 666.01,
    y: 69.235,
    fontFamily: "Arial"
  }, "\n        Muskingum\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.69,
    y: 98.09,
    width: 65.02,
    height: 60.61,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.57625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.19999999999999,
    y: 128.395,
    fontFamily: "Arial"
  }, "\n        Clermont\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.69,
    y: 158.7,
    width: 65.02,
    height: 61.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.19999999999999,
    y: 189.45,
    fontFamily: "Arial"
  }, "\n        Scioto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.69,
    y: 220.2,
    width: 65.02,
    height: 61.78,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.178
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.19999999999999,
    y: 251.08999999999997,
    fontFamily: "Arial"
  }, "\n        Tuscarawas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.69,
    y: 281.98,
    width: 65.02,
    height: 63.9,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.19999999999999,
    y: 313.93,
    fontFamily: "Arial"
  }, "\n        Miami\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.69,
    y: 345.88,
    width: 65.02,
    height: 68.6,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.288571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.19999999999999,
    y: 380.18,
    fontFamily: "Arial"
  }, "\n        Belmont\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.69,
    y: 414.48,
    width: 65.02,
    height: 69.47,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.288571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.19999999999999,
    y: 449.21500000000003,
    fontFamily: "Arial"
  }, "\n        Portage\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.69,
    y: 483.96,
    width: 65.02,
    height: 69.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.224444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.19999999999999,
    y: 518.745,
    fontFamily: "Arial"
  }, "\n        Ashtabula\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.69,
    y: 553.53,
    width: 65.02,
    height: 72.98,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.19999999999999,
    y: 590.02,
    fontFamily: "Arial"
  }, "\n        Allen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.69,
    y: 626.51,
    width: 65.02,
    height: 73.49,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.224444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.19999999999999,
    y: 663.255,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.71,
    y: 98.09,
    width: 60.21,
    height: 79.7,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.035
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.815,
    y: 137.94,
    fontFamily: "Arial"
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 201.92,
    y: 98.09,
    width: 62.06,
    height: 79.7,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.865714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 232.95,
    y: 137.94,
    fontFamily: "Arial"
  }, "\n        Licking\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.98,
    y: 98.09,
    width: 67.03,
    height: 79.7,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.703
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.495,
    y: 137.94,
    fontFamily: "Arial"
  }, "\n        Columbiana\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 331.01,
    y: 98.09,
    width: 67.99,
    height: 79.7,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.49875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 365.005,
    y: 137.94,
    fontFamily: "Arial"
  }, "\n        Richland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 399,
    y: 98.09,
    width: 84.61,
    height: 79.7,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.940000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 441.305,
    y: 137.94,
    fontFamily: "Arial"
  }, "\n        Clark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 483.61,
    y: 98.09,
    width: 101.8,
    height: 79.7,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 534.51,
    y: 137.94,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 585.41,
    y: 98.09,
    width: 114.59,
    height: 79.7,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.283333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 642.7049999999999,
    y: 137.94,
    fontFamily: "Arial"
  }, "\n        Butler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.71,
    y: 177.78,
    width: 103.07,
    height: 99.36,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.42
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 193.245,
    y: 227.46,
    fontFamily: "Arial"
  }, "\n        Trumbull\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.71,
    y: 277.15,
    width: 103.07,
    height: 102.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.155
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 193.245,
    y: 328.615,
    fontFamily: "Arial"
  }, "\n        Lorain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.71,
    y: 380.07,
    width: 103.07,
    height: 148.37,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.88375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 193.245,
    y: 454.255,
    fontFamily: "Arial"
  }, "\n        Mahoning\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.71,
    y: 528.45,
    width: 103.07,
    height: 171.55,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.613999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 193.245,
    y: 614.225,
    fontFamily: "Arial"
  }, "\n        Stark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.78,
    y: 177.78,
    width: 136.42,
    height: 161.5,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 312.99,
    y: 258.53,
    fontFamily: "Arial"
  }, "\n        Lucas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 381.2,
    y: 177.78,
    width: 158.7,
    height: 161.5,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.87
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 460.54999999999995,
    y: 258.53,
    fontFamily: "Arial"
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 539.9,
    y: 177.78,
    width: 160.1,
    height: 161.5,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.683333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 619.9499999999999,
    y: 258.53,
    fontFamily: "Arial"
  }, "\n        Summit\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.78,
    y: 339.28,
    width: 224.05,
    height: 158.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.8575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 356.805,
    y: 418.71,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.78,
    y: 498.14,
    width: 224.05,
    height: 201.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.2325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 356.805,
    y: 599.0699999999999,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.83,
    y: 339.28,
    width: 231.17,
    height: 360.72,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 28.89625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 584.415,
    y: 519.64,
    fontFamily: "Arial"
  }, "\n        Cuyahoga\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1968);
export default __webpack_public_path__ + "static/media/1968.340afd3988ccabea699129f0995e9769.svg";
export { ForwardRef as ReactComponent };